module.exports = __webpack_public_path__ + "img/gary_meowing.7a36f7de.jpg";